import React from 'react';

const InnovativeTechChallenge: React.FC = () => {
  return (
    <div className="text-justify py-4">
      <p className="mb-4">
        Pada ajang <b>Indonesia Innovative Technology Challenge (IIT Challenge) 2024</b>, kategori <b>Innovative Technology Challenge</b> menjadi salah satu kompetisi yang paling menarik perhatian. Dibagi menjadi dua level, yaitu <b>Junior</b> untuk siswa sekolah dasar (SD) dan <b>Senior</b> untuk siswa SMP hingga SMA, kategori ini menggabungkan kreativitas, inovasi, dan teknologi dalam satu wadah kompetisi yang penuh semangat.
      </p>
      
      <h2 className="text-2xl font-bold mb-4 mt-6">Tantangan yang Menginspirasi</h2>
      <p className="mb-4">
        Kompetisi ini dirancang untuk memacu ide-ide kreatif para peserta dalam menciptakan solusi teknologi yang relevan dengan kehidupan sehari-hari.
      </p>
      
      <h3 className="text-xl font-bold mb-3 mt-4">Level Junior (SD) dan Level Senior (SMP-SMA)</h3>
      <ul className="list-disc pl-6 mb-6 space-y-2">
        <li>
          Peserta diminta mengajukan ide dengan prototype inovatif, seperti alat bantu belajar digital, perangkat ramah lingkungan, atau permainan edukasi interaktif.
        </li>
        <li>
          Penilaian mencakup aspek inovasi, dampak solusi terhadap masyarakat, dan kemampuan peserta mempresentasikan ide mereka.
        </li>
      </ul>
      
      <h2 className="text-2xl font-bold mb-4 mt-6">Belajar dari Pengalaman</h2>
      <p className="mb-4">
        Selain berkompetisi, peserta juga mendapatkan banyak pembelajaran:
      </p>
      
      <ol className="list-decimal pl-6 mb-6 space-y-4">
        <li>
          <p><strong>Meningkatkan Keterampilan Berpikir Kritis</strong></p>
          <p>
            Peserta ditantang untuk memahami masalah dan mencari solusi inovatif dengan pendekatan logis dan kreatif.
          </p>
        </li>
        <li>
          <p><strong>Memahami Teknologi</strong></p>
          <p>
            Kompetisi ini memperkenalkan peserta pada dunia teknologi, seperti cara kerja perangkat pintar, desain aplikasi, dan pengembangan produk teknologi.
          </p>
        </li>
        <li>
          <p><strong>Melatih Kemampuan Presentasi</strong></p>
          <p>
            Setiap peserta harus mempresentasikan ide mereka di hadapan dewan juri, melatih keberanian dan kemampuan komunikasi.
          </p>
        </li>
      </ol>
      
      <h2 className="text-2xl font-bold mb-4 mt-6">Membangun Generasi Inovatif</h2>
      <p className="mb-6">
        Kategori Innovative Technology Challenge di IIT Challenge 2024 adalah bukti bahwa generasi muda Indonesia memiliki potensi luar biasa dalam mengembangkan solusi teknologi yang bermanfaat. Kompetisi ini tidak hanya mencetak juara, tetapi juga menanamkan semangat inovasi dan kolaborasi sejak dini.
      </p>
      
      <h2 className="text-2xl font-bold mb-4 mt-6">Yuk, Jelajahi Keseruan IIT Challenge!</h2>
      <p className="mb-4">
        Untuk informasi lebih lanjut dan momen seru lainnya dari IIT Challenge 2024, kunjungi Instagram kami di <a href="https://instagram.com/iitchallenge2024" target='_blank' className="underline font-semibold text-defaultBlue">@iitchallenge2024</a> dan persiapkan dirimu untuk tantangan selanjutnya!
      </p>
      <p className='font-bold'>
        Mari dukung anak-anak Indonesia untuk terus berkarya dan menjadi inovator masa depan!
      </p>
    </div>
  );
};

export default InnovativeTechChallenge;